class ViewAllBrands extends HTMLElement {
    constructor() {
        super();
        this.viewAllBrandsBtn = this.querySelector('.js-view-all-brands');
        this.viewAllBrandsBtnWrapper = this.querySelector('.btn-group');
        this.brandsGrid = this.querySelector('.brands-grid');

        this.viewAllBrandsBtn.addEventListener('click', (event) => {
            event.preventDefault();
            this.toggleVisibility();
        });

        this.updateButtonVisibility();
    }

    updateButtonVisibility() {
        const childElements = this.brandsGrid.querySelectorAll('img, svg');
        const childCount = childElements.length;
        this.viewAllBrandsBtnWrapper.classList.toggle('hidden', childCount <= 7);
    }

    toggleVisibility() {
        this.viewAllBrandsBtn.classList.toggle('active');
        this.brandsGrid.classList.toggle('visible');
    }
}

customElements.define('view-all-brands', ViewAllBrands);